import { Pagination } from "@mui/material";
import useStateRef from 'react-usestateref';

import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";
import swal from 'sweetalert';
import {useLocation } from 'react-router-dom';

import config from "../../../config/config";
import apiPath from "../../../config/apipath";
import apiService from "../../../provider/apiService";
import "../../App.css";

const RateMasterTable = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [ratemaster, setRatemaster] = useState([]);
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();
  const [page, setpage, pageRef] = useStateRef('1');
  const [Search, setSearch, SearchRef] = useStateRef('');

  const [NewElg, setNewElg] = useState(false);
  const [EditElg, setEditElg,EditElgRef] = useStateRef(false);
  const [DeleteElg, setDeleteElg] = useState(false);
  const [ViewElg, setViewElg] = useState(false);
  const [btndisabled, setDisabled] = useState('disabled');
  

  const [metal, setMetal, metalRef] = useStateRef([]);
  const [purity, setPurity, purityRef] = useStateRef([]);

  const [currentDate, setcurrentDate] = useState(new Date().toJSON().slice(0, 10))
  ;

  const [Rate916, setRate916] = useState(0);
  const [Rate100, setRate100] = useState(0);
  const [RateOJ, setRateOJ] = useState(0);
  const [RatePlat, setRatePlat] = useState(0);
  const [RateSil, setRateSil] = useState(0);

  const location = useLocation();

  useEffect(() => {
    if (location.state!=undefined || location.state!=null){
    setNewElg(location.state.NewElg);
      setEditElg(location.state.EditElg);
      setDeleteElg(location.state.DeleteElg);
      setViewElg(location.state.ViewElg);

      sessionStorage.setItem("RateNew_NewElg", location.state.NewElg);
      sessionStorage.setItem("RateNew_EditElg", location.state.EditElg);
      sessionStorage.setItem("RateNew_DeleteElg", location.state.DeleteElg);
      sessionStorage.setItem("RateNew_ViewElg", location.state.ViewElg);
    }
    else
    {
      setNewElg(sessionStorage.getItem("RateNew_NewElg")==='true' ? true: false);
      setEditElg(sessionStorage.getItem("RateNew_EditElg")==='true' ? true: false);
      setDeleteElg(sessionStorage.getItem("RateNew_DeleteElg")==='true' ? true: false);
      setViewElg(sessionStorage.getItem("RateNew_ViewElg")==='true' ? true: false);
    }
      if (EditElgRef.current==true){
        setDisabled('');
      }
      else
      {
        setDisabled('disabled');
      }

    setpage(1);
    getRateMaster(1);

    setcurrentDate(new Date().toJSON().slice(0, 10));
    //getmetaltype();
    //getPurity();
  }, []);

  const ratemasterPg = (event, value) => {
    setpage(value);
    getRateMaster(currentpgRef.current);

  };

  async function getRateMaster(page) {
    try {
      let page_no = String(page)
      let Rows_Page = String(config.pageCount)
      let postData = {
        PageNumber: page_no,
        RowspPage: Rows_Page,
        Search:SearchRef.current

      }
      let results = await apiService.getRatemaster(apiPath.master.get.getRatemaster, postData);
      if (results != "-1") {
        setRatemaster(results.data[0]);
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function getmetaltype() {
    try {
      let results = await apiService.getItem(apiPath.master.get.getmetaltype);
      if (results != "-1") {
        setMetal(results.data[0]);
        console.log(metalRef.current, "check");
      }
    } catch (error) {
      console.log(error);
    }

  }

  async function getPurity() {
    try {
      let results = await apiService.getPurity(apiPath.master.get.getPurity);
      if (results != "-1") {
        setPurity(results.data[0]);
        console.log(purityRef.current, "CHECK2");
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function insertRateMaster() {
    try {
      let postData = 
        {
        SDate:currentDate,
        Rate916:Rate916,
        Rate100:Rate100,
        RateOJ:RateOJ,
        RatePlat:RatePlat,
        RateSil:RateSil
      };
      
      let results = await apiService.postCall(apiPath.master.insert.insertRateMaster, postData);
      if (results != "-1") {
        swal({
          title: "Success",
          text: "Successfully Added",
          icon: "success",
          button: "Ok"
        }).then(function () {
          setShow1(false);
          getRateMaster(currentpgRef.current);

        });

      }

    } catch (error) {
      console.log(error);
    }
  }


  async function getRateData(sdate) {

    let postData = {
      sdate: sdate
    }

    const results = await apiService.postCall("master/getRateData",postData);

   if (results != "-1") {
      
    setcurrentDate(results.data[0][0].Sdate.substring(0,10));
    setRate916(results.data[0][0].Rate916);
    setRate100(results.data[0][0].Rate100);
    setRateOJ(results.data[0][0].RateOJ);
    setRatePlat(results.data[0][0].RatePlat);
    setRateSil(results.data[0][0].RateSil);
  }
 
  }

  const handleShow1 = (data,sdate) => {
    setShow1(true);
   
    getRateData(sdate);

    if (data == 'add') {
      setSho('Add New');
      setShow('Save');
    } else {
      setSho('Edit');
      setShow('Update');
    }
  }

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">To Add, Modify Rate Master details.</h4>
              </div>
              <div>
                <div style={{ display: 'flex', marginLeft: '91px', alignItems: 'center' }}>
                <div style={{ paddingRight: '10px' }}>
                    <Form.Control type="search" value={Search}  onChange={(e)=>{setSearch(e.target.value)}} className="form-control mr-sm-2" placeholder="Search" aria-label="Search" />
                  </div>
                  <div >
                    <Button className="text-center btn-primary btn-sm btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={(e)=>{
                         setcurrentpg(1)
                         getRateMaster(currentpgRef.current)}}>
                                <i className="btn-inner">
                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </i>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col d-flex justify-content-end">
               {NewElg &&  <Button className="text-center btn-primary btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={() => { handleShow1('add',currentDate) }}>
                  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
                  <span>Add</span>
                </Button>}
                <Modal show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Rate</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-3" >
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-md-12 col-lg-12'>

                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-md-3'></div>
                                <div className='col-md-6'>
                                  <Form.Label>Date</Form.Label>
                                  <Form.Control  class="text-center" type="text" value={currentDate}  disabled={true} />
                                </div>
                                <div className='col-md-3'></div>
                              </div>
                            </div>

                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-md-12 col-lg-12'>
                                  <Table className="  table-sm border-bottom text-center ">
                                    <thead>
                                      <tr>
                                        <th>Metal</th>
                                        <th>Purity</th>
                                        <th>Rate</th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                    <tr>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtGold916" value="GOLD" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtPurity916" value="91.6" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                              <Form.Control className="form-control-sm" type="text" id="txtRate916" value={Rate916} onChange={(e)=>setRate916(e.target.value)} />
                                            </td>
                                    </tr>

                                    <tr>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtGold100" value="GOLD" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtPurity100" value="100" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                              <Form.Control className="form-control-sm" type="text" id="txtRate100" value={Rate100} onChange={(e)=>setRate100(e.target.value)} />
                                            </td>
                                    </tr>

                                    <tr>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtOJ" value="OLD GOLD" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtPurityOJ" value="100" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                              <Form.Control className="form-control-sm" type="text" id="txtRateOJ" value={RateOJ} onChange={(e)=>setRateOJ(e.target.value)} />
                                            </td>
                                    </tr>

                                    <tr>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtPlat" value="PLATINUM" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtPurityPlat" value="91.6" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                              <Form.Control className="form-control-sm" type="text" id="txtRatePlat" value={RatePlat} onChange={(e)=>setRatePlat(e.target.value)} />
                                            </td>
                                    </tr>

                                    <tr>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtSil" value="SILVER" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                            <Form.Control className="form-control-sm txtReadOnly" type="text" id="txtPuritySil" value="91.6" readonly="readonly" />
                                            </td>
                                            <td className="col-md-4" >
                                              <Form.Control className="form-control-sm" type="text" id="txtRateSil" value={RateSil} onChange={(e)=>setRateSil(e.target.value)} />
                                            </td>
                                    </tr>

                                  </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>



                          </div>
                        </div>
                      </div>
                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                      <Button variant="primary" disabled={btndisabled} onClick={() => {
                        insertRateMaster()
                      }
                      }>{show}
                      </Button>		{' '}
                      <Button variant="danger" onClick={handleClose1}>  Cancel </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
                <Table
                  responsive
                  striped
                  id="datatable"
                  className=""
                  data-toggle="data-table"
                >
                  <thead>
                    <tr>
                      <th>Date</th>
                     
                      <th></th>
                  
                    </tr>
                  </thead>
                  <tbody>
                    {ratemaster.map((item) => (
                      <tr>
                        <td>{item.date}</td>
                        {(EditElg || ViewElg) && 
                        <td>
                          <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit User" to="#" onClick={() => { handleShow1('edit',item.date) }} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>}
                      
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 0 3px 0px', width: '100%', justifyContent: 'space-between' }}>
                  <div>
                    Showing {(currentpgRef.current - 1) * 10 + 1} to {currentpgRef.current * 10} of {totalCountRef.current} entries
                  </div>
                  <div>   <Pagination count={Math.ceil(totalCountRef.current / config.pageCount)} page={nopageRef.current} color="primary" onChange={ratemasterPg} />
                  </div>

                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default RateMasterTable;
